import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import ImmunizationsContainer from "./ImmunizationsContainer";

export default function ImmunizationPage(params) {
  const navigate = useNavigate();
  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Immunizations"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate("/user/hr/immunizations/add")}
        >
          Add
        </Button>
      </Flex>
      <ImmunizationsContainer />
    </Flex>
  );
}
